// Libraries
import React from 'react';
// Components
import { ModalImportantInfo } from '@components/modal';
// Constants
import { CurrentInformation, getModalInformation } from '@pages/electronic-payroll/constants/InformationImportant';
// Models
import { IModalInformationImportantProps } from '../models/ModalInformationImportant';
// Styles
import './ModalInformationImportant.scss';

export const ModalInformationImportant: React.FC<IModalInformationImportantProps> = ({
    isOpen,
    onRequestClose,
    handleBack,
    mainAction,
    currentInformation = CurrentInformation.ENABLE_SERVICE,
    date,
    disabledConfirm = false,
    hiddenBackButton = false,
}) => {
    return (
        <ModalImportantInfo
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            handleBack={handleBack}
            mainAction={mainAction}
            hiddenBackButton={hiddenBackButton}
            confirm={currentInformation !== CurrentInformation.ERROR_TRANSMISSION}
            disabledConfirm={disabledConfirm}
            className="modal-information-important"
        >
            <div className="content__information">{getModalInformation(date)[currentInformation]}</div>
        </ModalImportantInfo>
    );
};
